import { get, post, put, del, patch } from '../services/api';

const IDENTIFICATION_API_BASE = '/identification'; // Ex: /api/auth

export const fetchRessource = async (ressource, params) => {
    try {
        return await get(`${IDENTIFICATION_API_BASE}/${ressource}`, params);
    } catch (error) {
        console.error('Error fetching resources:', error);
        throw error;
    }
}

export const fetchOneRessource = async (ressource, id) => {
    try {
        return await get(`${IDENTIFICATION_API_BASE}/${ressource}/${id}`);
    } catch (error) {
        console.error('Error fetching one ressource:', error);
        throw error;
    }
}


export const addRessource = async (ressource, data) => {
    try {
        return await post(`${IDENTIFICATION_API_BASE}/${ressource}`, data);
    } catch (error) {
        throw error;
    }
}

export const updateRessource = async (ressource, id, data) => {
    try {
        return await put(`${IDENTIFICATION_API_BASE}/${ressource}/${id}`, data);
    } catch (error) {
        throw error;
    }
}

export const patchRessource = async (ressource, id, data) => {
    try {
        return await patch(`${IDENTIFICATION_API_BASE}/${ressource}/${id}`, data);
    } catch (error) {
        throw error;
    }
}



export const deleteRessource = async (ressource, id) => {
    try {
        return await del(`${IDENTIFICATION_API_BASE}/${ressource}/${id}`);
    } catch (error) {
        console.error('Error deleting espece:', error);
        throw error;
    }
}


export const addRessourceTranslation = async (ressource, id, data) => {
    try {
        return await post(`${IDENTIFICATION_API_BASE}/${ressource}/${id}/translations`, data);
    } catch (error) {
        throw error;
    }
};
export const updateRessourceTranslation = async (ressource, id, data) =>{
    try{
        return await put(`${IDENTIFICATION_API_BASE}/${ressource}/translations/${id}`, data)
    }catch(error){
        throw error;
    }
};
export const deleteRessourceTranslation = async (ressource, id) => {
    try{
        return await del(`${IDENTIFICATION_API_BASE}/${ressource}/translations/${id}`)
    }catch(error){
        console.error('Error deleting ressource translation:', error)
        throw error;
    }
}
